import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_analyze_mini",
  "use": "icon-ic_analyze_mini-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_analyze_mini\">\n<path d=\"M6.88985 7V15.9778H18.0086V17.1H5.5V7H6.88985ZM17.5172 8.84768L18.5 9.64122L14.534 12.8435L12.4492 11.1606L9.466 13.569L8.48323 12.7755L12.4492 9.57314L14.534 11.256L17.5172 8.84768Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol